<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <app-card>
    <app-datatable
      ref="datatable"
      :btn-dialog="userHasPermission('store')"
      :form-loading.sync="formLoading"
      :form.sync="dialog"
      :headers="headers"
      :modal-title="datatableDialogTitle"
      :url="tableUrl"
      @submitClickForm="submitClickForm"
    >
      <template #form="props">
        <app-form
          ref="form"
          :errors="formErrors"
          :submit="submitForm"
        >
          <v-container>
            <app-row>
              <app-date-picker
                v-model="selectedItem.date"
                cols="12"
                name="date"
                required
                sm="6"
              />
              <app-number-input
                v-model="selectedItem.start_hour"
                cols="12"
                name="start_hour"
                required
                sm="6"
              />
              <app-number-input
                v-model="selectedItem.end_hour"
                cols="12"
                name="end_hour"
                required
                sm="6"
              />
              <app-number-input
                v-model="selectedItem.appointment_minutes"
                cols="12"
                name="appointment_minutes"
                required
                sm="6"
              />
            </app-row>
          </v-container>
        </app-form>
      </template>

      <template #item.control="{item}">
        <app-dt-btn
          v-if="userHasPermission('update')"
          :disabled="loadingDatatable"
          update
          @click="showUpdateDialog(item)"
        />
        <app-dt-btn
          v-if="userHasPermission('destroy')"
          :disabled="loadingDatatable"
          destroy
          @click="deleteItem(item)"
        />
      </template>
    </app-datatable>
  </app-card>
</template>
<script>
import { DatatableMixin, MetaInfoMixin } from '@mixins'

export default {
  name: 'AppointmentDates',
  helperApiName: 'appointmentDate',
  mixins: [MetaInfoMixin, DatatableMixin],
  data () {
    return {
      modelPermission: 'Utilities.AppointmentDate',
      headers: [
        'date',
        'start_hour',
        'end_hour',
        'appointment_minutes',
        'control'
      ]
    }
  },
  computed: {
    defaultSelectedItem () {
      return {}
    }
  },
  mounted () {
    this.checkPermission('index')
  }
}
</script>
